import { getItemsFromCollection } from "directus/src/operations";

export async function fetchSurveysAverage({ jobId }) {
  try {
    const query = {
      fields: [
        "id",
        "job",
        "questions.id",
        "questions.question",
        "questions.questions_id.question",
        "questions.question.question",
        "questions.question.category.name",
        "questions.response",
      ],
      filter: {
        job: {
          _eq: jobId,
        },
        status: {
          _eq: "submitted",
        },
      },
    };
    const response = await getItemsFromCollection("surveys", query);

    // Simply return the array of surveys
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

